// actionTypes
export const UPDATE_TITLE = "UPDATE_TITLE";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_SLUG = "UPDATE_SLUG";
export const UPDATE_TAGLINE = "UPDATE_TAGLINE";
export const UPDATE_FEATURE_IMAGE = "UPDATE_FEATURE_IMAGE";
export const UPDATE_TECHNOLOGIES = "UPDATE_TECHNOLOGIES";
export const UPDATE_PLATFORM = "UPDATE_PLATFORM";
export const UPDATE_INDUSTRY = "UPDATE_INDUSTRY";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const UPDATE_FIRST_DESC = "UPDATE_FIRST_DESC";
export const UPDATE_YTVIDEOLINK1 = "UPDATE_YTVIDEOLINK1";
export const UPDATE_YTVIDEOLINK2 = "UPDATE_YTVIDEOLINK2";
export const UPDATE_YTVIDEOLINK3 = "UPDATE_YTVIDEOLINK3";
export const UPDATE_DESC_IMAGE_1 = "UPDATE_DESC_IMAGE_1";
export const UPDATE_DESC_IMAGE_2 = "UPDATE_DESC_IMAGE_2";
export const UPDATE_DESC_IMAGE_3 = "UPDATE_DESC_IMAGE_3";
export const UPDATE_DESC_IMAGE_4 = "UPDATE_DESC_IMAGE_4";
export const UPDATE_HIGHLIGHT_IMAGE = "UPDATE_HIGHLIGHT_IMAGE";
export const UPDATE_META_TITLE = "UPDATE_META_TITLE";
export const UPDATE_META_DESCRIPTION = "UPDATE_META_DESCRIPTION";

// action creators
export const updateTitle = (title) => ({
  type: UPDATE_TITLE,
  payload: title,
});

export const updateCategory = (category) => ({
  type: UPDATE_CATEGORY,
  payload: category,
});

export const updateSlug = (slug) => ({
  type: UPDATE_SLUG,
  payload: slug,
});

export const updateTagline = (tagline) => ({
  type: UPDATE_TAGLINE,
  payload: tagline,
});

export const updateFeatureImage = (image) => ({
  type: UPDATE_FEATURE_IMAGE,
  payload: image,
});

export const updateTechnologies = (technologies) => ({
  type: UPDATE_TECHNOLOGIES,
  payload: technologies,
});

export const updatePlatform = (platform) => ({
  type: UPDATE_PLATFORM,
  payload: platform,
});

export const updateIndustry = (industry) => ({
  type: UPDATE_INDUSTRY,
  payload: industry,
});

export const updateCountry = (country) => ({
  type: UPDATE_COUNTRY,
  payload: country,
});

export const updateFirstDesc = (description) => ({
  type: UPDATE_FIRST_DESC,
  payload: description,
});

export const updateYtVideoLink1 = (link) => ({
  type: UPDATE_YTVIDEOLINK1,
  payload: link,
});
export const updateYtVideoLink2 = (link) => ({
  type: UPDATE_YTVIDEOLINK2,
  payload: link,
});
export const updateYtVideoLink3 = (link) => ({
  type: UPDATE_YTVIDEOLINK3,
  payload: link,
});

export const updateDescImage1 = (image) => ({
  type: UPDATE_DESC_IMAGE_1,
  payload: image,
});

export const updateDescImage2 = (image) => ({
  type: UPDATE_DESC_IMAGE_2,
  payload: image,
});

export const updateDescImage3 = (image) => ({
  type: UPDATE_DESC_IMAGE_3,
  payload: image,
});

export const updateDescImage4 = (image) => ({
  type: UPDATE_DESC_IMAGE_4,
  payload: image,
});

export const updateHighlightImage = (highlightImage) => {
  return {
    type: UPDATE_HIGHLIGHT_IMAGE,
    payload: highlightImage,
  };
};

export const updateMetaTitle = (metaTitle) => ({
  type: UPDATE_META_TITLE,
  payload: metaTitle,
});

export const updateMetaDescription = (metaDescription) => ({
  type: UPDATE_META_DESCRIPTION,
  payload: metaDescription,
});
